import React, { isValidElement, MouseEventHandler, ReactNode } from 'react';

import { cn } from '@/utils/cn';

import Loading from '../Loading';
import LoadingIcon from '../Loading/icon';
import styles from './style.module.scss';

interface ButtonProps {
  children: React.ReactNode;
  className?: string;
  type?: 'default' | 'disabled' | 'link' | 'primary' | 'border';
  disabled?: boolean;
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
}

const isFragment = (child: any): boolean => {
  return child && React.isValidElement(child) && child.type === React.Fragment;
};

const dealSaveText = (children: ReactNode): ReactNode => {
  return React.Children.map(children, (child) => {
    if (child === null || child === undefined) {
      return;
    }

    if (typeof child === 'string') {
      return <span>{child}</span>;
    }

    if (isFragment(child)) {
      return <span>{child}</span>;
    }

    return child;
  });
};

export const Button = ({
  children,
  className,
  type = 'primary',
  disabled,
  ...props
}: ButtonProps) => {
  return (
    <button
      {...props}
      className={cn(
        'inline-flex items-center justify-center rounded-lg p-2 text-center font-semibold text-base box-border ',
        {
          ' bg-primary text-[#F0F0FA] hover:bg-primary_weak hover:text-on_primary transition-colors':
            type === 'primary',
        },
        {
          'bg-[#5959E5] opacity-60': disabled,
        },
        {
          ' border border-primary_light text-primary_light hover:bg-primary_A16':
            type === 'border',
        },
        className,
      )}
      disabled={disabled}
    >
      {dealSaveText(children)}
    </button>
  );
};

/**
 * 1.0 按钮
 */

interface ButtonProps {
  icon?: ReactNode;
  onClick?: MouseEventHandler<HTMLButtonElement>;
  disabled?: boolean;
  className?: string;
  loading?: boolean;
  style?: any;
}

const NewButton: React.FC<ButtonProps> = ({
  children,
  icon,
  onClick,
  disabled = false,
  loading = false,
  className,
  style,
}) => {
  return (
    <button
      style={style}
      onClick={(e) => {
        if (loading) {
          return;
        }
        onClick && onClick(e);
      }}
      disabled={disabled}
      className={`relative ${styles.button} ${disabled ? styles.disabled : ''} ${loading ? styles.loading : ''} ${className || ''}`}
    >
      {icon && <span>{icon}</span>}
      {loading && <LoadingIcon size={20} color="#fff" />}
      {dealSaveText(children)}
    </button>
  );
};

export default NewButton;
